function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem('wishlist') || '[]');
  } catch (e) {
    return [];
  }
}

function saveWishlist(wishlist) {
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
}

function updateWishlistCount() {
  const wishlist = getWishlist();
  document.querySelectorAll('.wishlist-count').forEach((el) => {
    el.textContent = wishlist.length;
    el.style.display = wishlist.length > 0 ? 'inline-flex' : 'none';
  });
}

function removeFromWishlist(id) {
  let wishlist = getWishlist();
  wishlist = wishlist.filter((item) => Number(item.id) !== Number(id));
  saveWishlist(wishlist);
  updateWishlistCount();
  renderWishlist();
}

function renderWishlist() {
  const container = document.getElementById('wishlist-container');
  const wishlist = getWishlist();

  if (!container) return;

  if (wishlist.length === 0) {
    container.innerHTML =
      '<p class="wishlist-empty">Je verlanglijstje is leeg. <a href="/collections/new">Bekijk alle producten</a></p>';
    return;
  }

  container.innerHTML = '';

  wishlist.forEach((product) => {
    const card = document.createElement('div');
    card.className = 'wishlist-card';

    const comparePriceHtml =
      product.comparePrice && product.comparePrice !== product.price
        ? `<span class="wishlist-card__price"><s style="color:#999; margin-right:6px;">${product.comparePrice}</s><span style="color:#c0392b;">${product.price}</span></span>`
        : `<span class="wishlist-card__price">${product.price || ''}</span>`;

    card.innerHTML = `
      <a href="${product.url || '#'}">
        <img class="wishlist-card__image" src="${product.image || ''}" alt="${product.title || ''}">
      </a>
      <div class="wishlist-card__info">
        <a href="${product.url || '#'}" class="wishlist-card__title">${product.title || ''}</a>
        ${comparePriceHtml}
      </div>
      <div class="wishlist-card__actions">
        <a class="wishlist-card__view" href="${product.url || '#'}">Bekijk product</a>
        <button class="wishlist-card__remove" type="button" data-remove-id="${product.id}">✕</button>
      </div>
    `;

    container.appendChild(card);
  });

  container.querySelectorAll('[data-remove-id]').forEach((button) => {
    button.addEventListener('click', function () {
      removeFromWishlist(this.dataset.removeId);
    });
  });
}

function startWishlistPage() {
  renderWishlist();
  updateWishlistCount();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startWishlistPage);
} else {
  startWishlistPage();
}

window.addEventListener('pageshow', startWishlistPage);